import { AddDeviceToUnitQueryArg } from '../types/query-arg';
import { AddDeviceToUnitQueryBody } from '../types/query-body';

export const addDeviceToUnitQueryBody = ({
  device: { id, endpointId },
  unitId,
}: AddDeviceToUnitQueryArg): AddDeviceToUnitQueryBody => ({
  actionType: 'AddToUnit',
  endpointId,
  id,
  update: { unitId },
});
